export const SDK_VERSION = 'v9.0';
export const EVENTS_VERSION = '2.0';
